import { type ELeadStage } from 'src/services/api/leads/types';

export const API_INBOXES_PATH = 'api/landlord/conversations/inboxes';
export const API_INBOX_FAVORITES_PATH = 'api/landlord/conversations/inboxes/favorites';

export const INITIAL_FILTERS: {
    assigneeIds: string[];
    ingestionSources: string[];
    leadStages: ELeadStage[];
    leadLabelIds: string[];
    excludeLeadLabelIds: string[];
    propertyIds: string[];
    hasNoProperty: boolean;
    propertyLabelIds: string[];
} = {
    assigneeIds: [],
    ingestionSources: [],
    leadStages: [],
    leadLabelIds: [],
    excludeLeadLabelIds: [],
    propertyIds: [],
    hasNoProperty: false,
    propertyLabelIds: [],
};
